import React from "react";
import withStyles from "react-jss";
import styles from "../styles";

class StyledRow extends React.Component {
	render() {
		let children = React.Children.map(this.props.children, (item) => {
			return React.cloneElement(item, { ...this.props });
		});
		return children;
	}
}
export default withStyles(styles)(StyledRow);
